// extracted by mini-css-extract-plugin
module.exports = {"text_mobile_center":"peace-of-mind_text_mobile_center__UrIjy"};